import { TextSubHeader } from '@carboncopyco/ui';
import { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { SelectorsField } from '../../../TransactionRuleForm';
import {
  BackIconButton,
  FormLayout,
  UpdateChangesButton,
} from '../../../TransactionRuleModal';
import { useEditTransactionRuleContext } from '../../EditTransactionRuleContext';

export const EditTransactionSelectorsStep = () => {
  const { goToGeneralSettingsStep, form } = useEditTransactionRuleContext();
  const [isLegalResponse, setIsLegalResponse] = useState<boolean>(true);

  const { handleSubmit, setValue, getFieldState, formState } = form;
  const { invalid, isDirty } = getFieldState('selectors');
  const defaultValue = formState.defaultValues.selectors;
  const updateChanges = async ({ selectors }) => {
    setValue('selectors', JSON.stringify(selectors), {
      shouldDirty: true,
    });
    goToGeneralSettingsStep();
  };

  const goBack = () => {
    if (invalid) {
      setValue('selectors', defaultValue, {
        shouldDirty: true,
      });
    }

    goToGeneralSettingsStep();
  };

  const isUpdateChangesButtonDisabled = () => {
    return !isLegalResponse || invalid || !isDirty;
  };

  return (
    <div>
      <div className="pt-5 px-5 flex items-center gap-2.5 text-ds-natural-700">
        <BackIconButton onClick={goBack} />
        <TextSubHeader
          color="text-ds-natural-700"
          label="Selectors"
        />
      </div>
      <div className="h-[656px]">
        <FormProvider {...form}>
          <FormLayout onSubmit={handleSubmit(updateChanges)}>
            <FormLayout.Header />
            <div className="flex-1 px-8 pt-7">
              <SelectorsField
                height={480}
                onError={(errors) => setIsLegalResponse(!errors.length)}
              />
            </div>
            <FormLayout.Footer>
              <div className="flex-1" />
              <UpdateChangesButton disabled={isUpdateChangesButtonDisabled()} />
            </FormLayout.Footer>
          </FormLayout>
        </FormProvider>
      </div>
    </div>
  );
};
